// Review issues dashboard.
import {
  CleaningToolReviewIssueType,
  ForgeReviewIssueActiveFilter,
  ForgeReviewIssueAssignmentFilter,
  ForgeReviewIssuesChainSnapshot,
  ForgeReviewIssuesDashboardResponse,
  ForgeReviewIssueSort,
} from '../../types/reviewIssues';
import { forgeRequest } from '../forgeRequest';
import { FORGE_DASHBOARDS_API_URL } from './endpoints';

export async function fetchReviewIssuesDashboard(
  token: string,
  filters?: {
    chainId?: number | null;
    issueType?: CleaningToolReviewIssueType | null;
    assignmentFilter?: ForgeReviewIssueAssignmentFilter | null;
    activeFilter?: ForgeReviewIssueActiveFilter | null;
    query?: string | null;
    updatedByValues?: string[] | null;
    sort?: ForgeReviewIssueSort | null;
    page?: number;
    limit?: number;
  }
): Promise<ForgeReviewIssuesDashboardResponse> {
  const params = new URLSearchParams();
  if (filters?.chainId) params.set('chain_id', String(filters.chainId));
  if (filters?.issueType) params.set('issue_type', filters.issueType);
  if (filters?.assignmentFilter) params.set('assignment_filter', filters.assignmentFilter);
  if (filters?.activeFilter) params.set('active_filter', filters.activeFilter);
  if (filters?.query) params.set('query', filters.query);
  filters?.updatedByValues?.forEach((value) => params.append('updated_by_values', value));
  if (filters?.sort) params.set('sort', filters.sort);
  if (filters?.page) params.set('page', String(filters.page));
  if (filters?.limit) params.set('limit', String(filters.limit));
  const query = params.toString();
  const requestKey = `${token}:${query}`;
  return forgeRequest<ForgeReviewIssuesDashboardResponse>(
    token,
    `${FORGE_DASHBOARDS_API_URL}/review-issues${query ? `?${query}` : ''}`,
    'Error fetching Forge review issues dashboard',
    { dedupeKey: ['fetchReviewIssuesDashboard', requestKey] }
  );
}

export async function refreshReviewIssuesDashboard(
  token: string,
  chainId: number
): Promise<ForgeReviewIssuesChainSnapshot> {
  return forgeRequest<ForgeReviewIssuesChainSnapshot>(
    token,
    `${FORGE_DASHBOARDS_API_URL}/review-issues/refresh`,
    'Error refreshing Forge review issues snapshot',
    {
      method: 'POST',
      body: {
        chain_id: chainId,
      },
    }
  );
}
